import styled, { css } from 'styled-components';

export const Container = styled.div(({ theme }) => {
  const space = 's4';
  const threshold = 'md';
  return css`
    & > * {
      display: flex;
      flex-wrap: wrap;
      /* ↓ Multiply by -1 to make negative */
      margin: calc(${theme.sz[space]} / 2 * -1);
    }

    & > * > * {
      flex-grow: 1;
      flex-basis: calc((${theme.sz[threshold]} - (100% - ${theme.sz[space]})) * 999);
      /* ↓ Half the value to each element, combining to make the whole */
      margin: calc(${theme.sz[space]} / 2);
    }
  `;
});

export const ButtonPositioner = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
`;
